import React, { useState, useRef } from "react";
import "./DeepDD.scss";
import { Modal, Button } from "react-bootstrap";
import axios from "axios";
import { Box } from "@mui/material";


function DeepDD() {
  const [showModal, setShowModal] = useState(false);
  const [modalContent, setModalContent] = useState("");
  const [loading, setLoading] = useState(false);
  const scriptLoadedRef = useRef(false);

  // 🔥 ONLY URL YOU NEED
  const phpUrl = "https://dev2.4pay.ca/lab/dociify3/ui/index.php";

  const handleOpenModal = async () => {
    setShowModal(true);
    setLoading(true);

    try {
      const response = await axios.get(phpUrl);
      setModalContent(response.data);
    } catch (error) {
      setModalContent("Error loading DeepDD module");
    } finally {
      setLoading(false);
    }
  };

    const handleClose = () => {
    setShowModal(false);
    setModalContent("");
    scriptLoadedRef.current = false; // ✅ reset so it works next time
    };

  return (
    <Box className="page-container settings-container">
      <Box className="header-container">
        <Box className="settings-page-title">
          Deep Due Diligence
        </Box>
        <Box>
          Run deep investigation, risk analysis, and compliance checks
          across entities using AI-driven intelligence.
        </Box>
      </Box>

      <Box className="settings-center-container">
        <Box className="row gap-3">

          {/* 🔥 CARD (same as CoFiLab style) */}
          <Box
            className="settings-card col-3"
            onClick={handleOpenModal}
          >
            <Box className="settings-card-title-container d-flex align-items-center">
              <p>Deep DD Engine</p>
            </Box>
            <div className="settings-card-body">
              Launch Deep Due Diligence investigation engine
              including crawl, reputation, OFAC, and risk scoring.
            </div>

            <a className="settings-card-link">
              Launch DeepDD
            </a>
          </Box>

        </Box>
      </Box>

      {/* 🔥 MODAL (same structure as CoFiLab) */}
      <Modal show={showModal} onHide={handleClose} className="custom-modal">
        <Modal.Header closeButton>
          <Modal.Title>Deep Due Diligence</Modal.Title>
        </Modal.Header>

        <Modal.Body className="modal_cofi">
          {loading ? (
            <div>Loading DeepDD...</div>
          ) : (
            <div
            ref={(el) => {
                if (el && modalContent && !scriptLoadedRef.current) {
                scriptLoadedRef.current = true; // ✅ prevent duplicate execution

                el.innerHTML = modalContent;

                const scripts = el.querySelectorAll("script");

                scripts.forEach((oldScript) => {
                    const newScript = document.createElement("script");

                    if (oldScript.src) {
                    newScript.src = oldScript.src;
                    } else {
                    newScript.textContent = oldScript.textContent;
                    }

                    document.body.appendChild(newScript);
                });
                }
            }}
            />
          )}
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </Box>
  );
}

export default DeepDD;